import { serializeParentOption } from 'bundles/crm/parent_helpers';

import type { TaskAttributes, TaskFormState } from 'bundles/apex/tasks/types';
import type { Reminder } from 'bundles/apex/reminders/types';

export function serializeTaskForm(
  task: Partial<TaskFormState>,
  { keepReminders, reminders }: { keepReminders?: boolean | null, reminders?: Reminder[] },
) {
  const { selectedParentType: _selectedParentType, ...taskForApi } = task;
  const serializedTask: Partial<TaskAttributes> = {
    ...taskForApi
  };

  serializeParentOption(serializedTask);

  if (keepReminders) {
    serializedTask.keepImmediateReminders = true;
  }

  if (reminders && reminders.length > 0) {
    serializedTask.remindersAttributes = reminders.map(reminder => ({
      ...reminder,
      sendOn: {
        ...reminder.sendOn,
        relativeDateId: 'deadline',
      },
    }));
  }

  delete serializedTask.reminders;

  if (task.contactsTasks) {
    serializedTask.contactsTasksAttributes = task.contactsTasks.map(contactsTask => ({
      id: contactsTask.id,
      contactId: contactsTask.contact.id,
      _destroy: contactsTask._destroy,
    }));
  }

  delete serializedTask.contactsTasks;

  return serializedTask;
}
